import React from 'react';

const Time = (props: {
	time: string
}) => {
	const { time } = props;
	return (
		<>
			{time.substring(0, 5)}
		</>
	);
};

Time.propTypes = {

};

export default Time;